module.exports = __webpack_public_path__ + "img/组 1188@2x.34fb0b10.png";